// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"846":"575bc70c","910":"575bc70c"}[chunkId] + ".chunk.css";
};